import { render, staticRenderFns } from "./UploadDialog.vue?vue&type=template&id=3dc076f4&"
import script from "./UploadDialog.vue?vue&type=script&lang=js&"
export * from "./UploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadDialog.vue?vue&type=style&index=0&id=3dc076f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports